import { render, staticRenderFns } from "./ForgotUsernameOptions.vue?vue&type=template&id=f2b940c2&scoped=true&"
import script from "./ForgotUsernameOptions.vue?vue&type=script&lang=js&"
export * from "./ForgotUsernameOptions.vue?vue&type=script&lang=js&"
import style0 from "./ForgotUsernameOptions.vue?vue&type=style&index=0&id=f2b940c2&prod&lang=css&"
import style1 from "./ForgotUsernameOptions.vue?vue&type=style&index=1&id=f2b940c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b940c2",
  null
  
)

export default component.exports